export const environment = {
  production: true,
  corePath: 'https://api-customer.poshvine.com/core_service/v1',
  corePathV2: 'https://api-customer.poshvine.com/cs/v1',
  offerPath: 'https://api-customer.poshvine.com/offer_service/v1',
  giftPathV2: 'https://offers-api.poshvine.com/offer_service/v2',
  offerPathV2: 'https://api-customer.poshvine.com/ps/v1',
  apiUrlBsV1: 'https://api-customer.poshvine.com/bs/v1/',
  apiUrlBsInternal: 'https://api.poshvine.com/bs/internal/',
  apiUrlPaV1: 'https://api-customer.poshvine.com/pa/v1/',
  apiUrlLsV1: 'https://api-customer.poshvine.com/ls/v1/',
  baseUrl: 'https://api-customer.poshvine.com/',
  apiUrl: 'https://rewardshub-stage-api.poshvine.com/api/v1/',
  stagingUrl: 'https://rewardshub-stage-api.poshvine.com/',
  perksUrl: 'https://sandbox-api.poshvine.com/ps/rewardshub/',
  rewardsHubApiUrl: 'https://rewards-api.poshvine.com/api/v1/',
  analytics:
    'https://assets.adobedtm.com/8e068bb67c90/07a78f6404f1/launch-5e1bff55b076.min.js',
  gmApiKey: 'AIzaSyAXREnbpzSGulf8xS5J43tsYwrbBFltR7k', //'AIzaSyC2AtPyxZua0AcvWyoPZi-M_WuXoOo_gRc'
  ipstackKey: '022375a36968cebce87e10e1c6447ef6',
  campaignPath: 'https://api-customer.poshvine.com/cas/v1/',
  campaignEnterprisePath: 'https://api-customer.poshvine.com/cas/enterprise/',
  welcomeBenefitCampaignId: '7734a634-998f-4859-9a3b-7b654bdbb0e5',
  silverSpoonCategoryId: '8a15fa9e-30ca-495d-86aa-7f15c9c35725',
  silverSpoonSubOffersInCityCategoryId: '315dc1ad-1569-4e9d-88ee-75a29ebd7dff',
  silverSpoonSubOrderinginCategoryId: '7026ae60-431c-4ba2-a77e-e39123bc5db7',
  sentryDsn:
    'https://9b46c96396c1e7792a6e5e8a444cc811@o515678.ingest.us.sentry.io/4507293463937025',
  SENTRY_ORG: 'rzp',
  SENTRY_PROJECT: 'offers-app-au',
  SENTRY_AUTH_TOKEN:
    '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',
  CUSTOM_CAMPAIGN_FLOW_CAMPAIGN_IDS: ['b0c0f706-aaab-44fc-9c69-9dcaa3b10c89']
};
